import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./components/theme";
import { FeedbackProvider } from "../src/components/FeedbackContext";
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <FeedbackProvider>
       <BrowserRouter>
      <ChakraProvider theme={theme}>
        <App />
      </ChakraProvider>
      </BrowserRouter>
    </FeedbackProvider>
  </React.StrictMode>
);
